import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { StrategicCommercialZoneService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  StrategicCommercialZoneCreateDto,
  StrategicCommercialZoneDto,
  StrategicCommercialZoneExcelDownloadDto,
  StrategicCommercialZoneUpdateDto,
} from '../proxy/planning/dtos/strategic-commercial-zone';
import { STRATEGICCOMMERCIALZONE_CONFIG, STRATEGICCOMMERCIALZONE_FIELDS } from './strategic-commercial-zone.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-strategic-commercial-zone',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, StrategicCommercialZoneService, ConfirmationService],
  templateUrl: './strategic-commercial-zone.html',
  styleUrl: './strategic-commercial-zone.scss',
})
export class StrategicCommercialZone extends BaseCrudComponent<
  StrategicCommercialZoneDto,
  StrategicCommercialZoneCreateDto,
  StrategicCommercialZoneUpdateDto,
  StrategicCommercialZoneExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(StrategicCommercialZoneService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('StrategicCommercialZone', ids),
  };
  config = STRATEGICCOMMERCIALZONE_CONFIG;
  fields = STRATEGICCOMMERCIALZONE_FIELDS;

  protected prepareUpdateDto(data: any, selected: StrategicCommercialZoneDto): StrategicCommercialZoneUpdateDto {
    return {
      name: data.name,
      remsoftName: data.remsoftName,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'StrategicCommercialZone';
  }
}
